import React from "react";
import styled from "styled-components";
import { Fade } from "react-awesome-reveal";
import Matrix from "../components/matrix";
import TextBox from "../components/TextBox";
import { NavLink } from "react-router-dom";
const More = () => {
  return (
    <Wrapper>
      <div className="container">
        <div className="text-section">
          <div className="title-text">
            <Fade bottom cascade duration={600}>
              <h1>More</h1>
            </Fade>
          </div>
        </div>
      </div>
      <div className="container info">
        <Fade bottom duration={600}>
          <TextBox title="More from xor">
            <div className="icon-div">
              <span className="x0r">⊕</span>
              <p>
                Main{" "}
                <a href="https://www.x0rart.com/" target="_blank">
                  Website
                </a>
              </p>
            </div>
            <div className="icon-div">
              <span className="x0r">⊕</span>
              <p>
                Coinbase NFT{" "}
                <a
                  href="https://open.spotify.com/episode/7eHVAj9CY7cc6urVsyAf0v"
                  target="_blank"
                >
                  Podcast
                </a>
              </p>
            </div>
            <div className="icon-div">
              <span className="x0r">⊕</span>
              <p>
                That's Nifty{" "}
                <a
                  href="https://open.spotify.com/episode/69M2CIIugrdUPkJ5HoLNvy"
                  target="_blank"
                >
                  Podcast
                </a>
              </p>
            </div>
            <div className="icon-div">
              <span className="x0r">⊕</span>
              <p>
                uJenny DAO{" "}
                <a
                  href="https://www.youtube.com/watch?v=ZSNeyTreBfQ&list=PLYEJY9sUq3emAph75a96yC0HPftToRqQD&index=4"
                  target="_blank"
                >
                  Podcast
                </a>
              </p>
            </div>
            <div className="icon-div">
              <span className="x0r">⊕</span>
              <p>
                Gas Burn Recap{" "}
                <a
                  href="https://medium.com/@x0rart/gas-nft-why-we-burn-7027ac6ac55e"
                  target="_blank"
                >
                  Article
                </a>
              </p>
            </div>
            <div className="icon-div">
              <span className="x0r">⊕</span>
              <p>
                web3 with a16z: Securing and Evolving NFTS{" "}
                <a
                  href="https://open.spotify.com/episode/2iibUyQSrh504gRZmVefYp?si=d6bf67d7e4a04ef5"
                  target="_blank"
                >
                  Article
                </a>
              </p>
            </div>
          </TextBox>
        </Fade>
      </div>
      <Matrix />
    </Wrapper>
  );
};

const Wrapper = styled.main`
  background-color: #000;
  margin: 0;
  min-height: 100vh;
  color: #fff;
  position: relative;
  z-index: 1;
  padding: 0 3rem;

  div.container {
    display: flex;
    margin: 0 auto;
    padding-top: 200px;
    z-index: 1;
    max-width: 1200px;
    div.text-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;
      h1 {
        font-size: 4.5rem;
        font-family: "Request", sans-serif;
      }
      .button-container {
        display: flex;
      }
    }
  }
  div.info {
    padding-top: 4rem;
    flex-direction: column;
  }
  div.icon-div {
    display: flex;
    align-items: center;
  }

  span.x0r {
    font-size: 3rem;
    margin-bottom: 1rem;
    margin-right: 1rem;
  }

  @media (max-width: 1247px) {
    div.container {
      div.text-section {
        flex: 1;
        h1 {
          font-size: 4.25rem;
        }
      }
    }
    div.info {
      padding-top: 3rem;
    }
  }
  @media (max-width: 1011px) {
    div.container {
      flex-direction: column;
      div.text-section {
        flex: 1;
        h1 {
          font-size: 3.5rem;
        }
      }
    }
    div.info {
      padding-top: 2rem;
    }
  }
  @media (max-width: 605px) {
    padding: 0 1rem;
    div.container {
      padding-top: 6.5rem;
      div.text-section {
        margin-bottom: 3rem;
        h1 {
          font-size: 2.5rem;
        }
      }
    }
    div.info {
      padding-top: 2rem;
    }
  }
`;

export default More;
